import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { getCurrentPath, Path } from "@faire/web--source/common/Path";
/**
 * Generates a url using the current path as base with the page as a query param.
 *
 * Omits the first page (page == 1)
 *
 * i.e `/current-path?page=2`
 *
 * @param pageNumber
 */ export var buildPageLink = function(pageNumber) {
    var path = getCurrentPath().delete("page");
    if (pageNumber === 1) {
        return path.toString();
    }
    return path.append({
        page: pageNumber.toString()
    }).toString();
};
/**
 * Generates a url using the current path as base by updating the passed param
 * and removes all other passed params.
 *
 * Omits if the param value is an empty string.
 *
 * ```
 * // e.g given `/current-path?query=here&page=2&sort=new`
 * buildParamLink("query", "updateQuery", ["sort"])
 * // returns `/current-path?query=updateQuery&page=2`
 * ```
 *
 * @param paramName query param key to be updated
 * @param paramValue query param value use
 * @param otherParamsToRemove list of query param keys to remove. All other params will be remain untouched
 */ export var buildParamLink = function(paramName, paramValue) {
    var otherParamsToRemove = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var path = getCurrentPath().delete(paramName);
    otherParamsToRemove.forEach(function(param) {
        return path.delete(param);
    });
    if (paramValue !== "") {
        path.append(_define_property({}, paramName, paramValue));
    }
    return path.toString();
};
/**
 * Generates a URL using the given localized url and an object map of query parameters
 *
 * ```
 * // e.g given localizedUrl = `/current-path?query=here&page=2&sort=new`, queryParams = {referrer: "google"}
 * // returns `/current-path?query=updateQuery&sort=new&referrer=google`
 * ```
 *
 * @param localizedUrl url
 * @param queryParams mapping of query params to add
 */ export var localizedUrlWithQueryParams = function(localizedUrl, queryParams) {
    return new Path(new URL(getLocationOrThrow().origin + localizedUrl)).append(queryParams).toString();
};
/**
 * Creates a new path by appending a query string to the current path.
 * queryString can have a leading "?".
 *
 * @param path
 * @param queryString
 */ export var appendQueryStringToPath = function(path, queryString) {
    return new Path({
        pathname: path.pathname,
        search: [
            path.searchParams.toString(),
            queryString.replace("?", "")
        ].join("&")
    });
};
